import { CloseIcon } from 'assets/icons';
import Container from 'react-bootstrap/Container';
import FormControl from 'react-bootstrap/FormControl';
import styled from 'styled-components';

export const StyledComponentCloseIcon = styled.div`
  width: 32px;
  height: 32px;
  padding: 5px;
  margin-top: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  left: 5%;
`;

export const MapsParentContainer = styled(Container)`
  height: 100vh !important;
  width: 100% !important;
  flex: 1;
`;

export const StyledHeader = styled.header`
  margin-top: 15px;
  box-shadow: ${({ theme }) => theme.components.footer.boxShadow};
`;

export const StyledCloseIcon = styled(CloseIcon)`
  width: 32px;
  height: 32px;

  > g > g {
    stroke: ${({ theme }) => theme.colors.deepPurple};
  }
`;

export const StyledField = styled(FormControl)`
  &:focus {
    box-shadow:
      0 2px 4px -1px rgba(17, 17, 53, 0.04),
      0 1px 10px 0 rgba(17, 17, 53, 0.04),
      0 4px 5px 0 rgba(17, 17, 53, 0.05);
    outline: none;
    border: ${({ theme }) => `1px solid ${theme.colors.deepPurple}`};
  }
`;
